import { gql } from "@apollo/client";

export const DELETE_REFERRAL_FORM_MUTATION = gql`
  mutation DeleteReferralFormMutation($formId: ID!) {
    deleteForm(formId: $formId)
  }
`;
